import { render } from "./z-editor.vue?vue&type=template&id=7975f7e8&scoped=true&lang=pug"
import script from "./z-editor.vue?vue&type=script&setup=true&lang=js"
export * from "./z-editor.vue?vue&type=script&setup=true&lang=js"

import "./z-editor.vue?vue&type=style&index=0&id=7975f7e8&scoped=true&lang=css"

import exportComponent from "E:\\D\\web\\pyCharm\\arhichat-3.4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7975f7e8"]])

export default __exports__